if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      //this part of the script is for the faq to be displayed on top of the page
      //this happens when there is a scrollTo parameter in the URL
    
      this.queryString = window.location.search;
      if(this.queryString) {
        this.urlParams = new URLSearchParams(this.queryString);
        this.scrollTo = this.urlParams.get('scrollTo')
        if (this.urlParams.get('addSections')) {
          this.addSections = this.urlParams.get('addSections').split(",")
        }
        
        //console.log('addSections', this.addSections)
        this.displayFAQ()
      }
      
      
      //these variables are for the sliding add to cart button at the header
      //this will only show in the product detail page(PDP). hence the inclusion of this.productInfoBtnClose in the if statement below
      //to this date of writing aug 2 when the sliding add to cart is clicked, the product form will have the position sticky
      //when the sliding add to cart button is clicked (it is the pink button at the top of the screen) and user will click the true add to cart button
      
      //now we will change that so whenever the sliding add to cart button is clicked product will automatically be added to cart
      //to need to click the true add to cart button in the product form again
      this.slidingAddToCartContainer = document.querySelector('.sliding-add-to-cart-container')
      this.productInfoBtnClose = document.querySelector('.product__info-wrapper-close-btn')
      if( this.slidingAddToCartContainer && this.productInfoBtnClose && !this.slidingAddToCartContainer.getAttribute("data-btn-function") ) {
/* 
//we will no longer be needing this since the sliding add to cart button will now directly add the product to the cart
        this.slidingAddToCartContainer.addEventListener('click', 
                this.addClassFromListUniv(document.querySelector('.product__info-wrapper.watch-distance'), 'product__info-wrapper-fix-to-screen') 
        )

        this.slidingAddToCartContainer.addEventListener('click', 
                this.removeClassFromListUniv(document.querySelector('.product__info-wrapper.watch-distance'), 'product__info-wrapper-fix-to-screen') 
        )
*/ 
        
        this.slidingAddToCartContainer.addEventListener('click', () => {
          if (this.form.requestSubmit) {
            this.form.requestSubmit();
          } else {
            this.form.submit();
          }
        })
          
      }
      
      //these variables too are for the sliding add to cart button at the header
      this.addToCartObserve = document.querySelector('.main-product-qty-and-btn')
      this.addToCartObserveBounds = {};
      this.elementCont = document.getElementById('distance-container2')
      if (this.addToCartObserve && this.addToCartObserveBounds ) {
        this.createObserver();
      }

      this.form = this.querySelector('form');
      if(this.form) {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      // notify me back in stock variables and event listeners
      this.notifyMeButton = document.querySelector('.notify-me-button');
      this.notifyMeMainContainer = document.querySelector('.notify-me-sub-background');
      this.notifyMeButtonClose = document.querySelector('.notify-me-close-btn');
      this.backInStockSubmitForm = document.querySelector('#notify-sub-form');
      this.notifyFormErrorMessage = document.querySelector('.notify-form-error-message')

      if (this.notifyMeButton && this.notifyMeMainContainer) {
        this.notifyMeButton.addEventListener('click', () => {
          this.notifyBtnClickedInit()
        })

        this.notifyMeButtonClose.addEventListener("click", () => {
          this.removeClassFromListUniv(this.notifyMeMainContainer, 'display-notify-modal')
        })

        if(this.backInStockSubmitForm) {
          this.backInStockSubmitForm.addEventListener('submit', this.submitBackInStock.bind(this))
        }
      }

  
    }

    ///////////////////////////////////////////////////////////////////////////////START OF THE FUNCTIONS

    displayFAQ() {

        if(this.scrollTo) {
          this.faqElement = document.querySelector(`#${this.scrollTo}`).parentElement
          this.faqElement.classList.add('faq-grg-to-fixed')
          const faqCloseBtn = document.createElement("button");
          faqCloseBtn.innerHTML = 'x'
          faqCloseBtn.classList.add('faqCloseBtn')
          //faqCloseBtn.disabled = true;

          if(this.addSections) {
            this.faqElement.classList.add('faq-grg-to-fixed-more-sec')
            this.addSections.forEach(section => {
              const clonedSection = document.querySelector(`#${section}`).cloneNode(true);
              this.faqElement.appendChild(clonedSection);
            })
          }


          if(this.faqElement.querySelector('.reveal-more-btn')) {
            setTimeout( () => {
              this.faqElement.querySelector('.reveal-more-btn').click();
            }, 500)
          }


          this.faqElement.appendChild(faqCloseBtn)
          faqCloseBtn.addEventListener('click', ()=> {
            this.hideFAQModal(faqCloseBtn)

          })
        } else {
          return
        }
    }

    hideFAQModal(faqCloseBtn) {
      this.faqElement.classList.remove('faq-grg-to-fixed')

      if(this.addSections) {
        this.addSections.forEach(section => {
          this.faqElement.removeChild(this.faqElement.querySelector(`#${section}`));
        })
      }

      this.faqElement.scrollIntoView({behavior: 'smooth', block: 'center'})
      faqCloseBtn.style.display = 'none'
    }

    

    //this can also be an alternate if we cannot click the show more button with JS
    revealAccordionElement(accordionContainer) {
      let accordionWrapper = accordionContainer.querySelector('.pmd-faq__accordian-faq__box.scrollbar--thin')
      //const accordionElement = accordionContainer.querySelectorAll('product__accordion')
      accordionWrapper.childNodes.forEach(element => {
        //element.classList.remove('hide-class')
        //console.log(element)
        element.classList.remove('hide-class')
      });

      accordionContainer.querySelector('.reveal-more-btn').classList.add('hide-class');
      accordionContainer.querySelector('.hide-more-btn').classList.remove('hide-class');
    }

  // universal function that can add and remove a class from an element start
    addClassFromListUniv(element, className) {
        element.classList.add(className)
    }

    removeClassFromListUniv(element, className) {
        element.classList.remove(className)
    }

    // universal function that can add and remove a class from an element end


    //notify me scripts start
    notifyBtnClickedInit() {
      //reset the notify me submit form
      document.getElementById('notify-sub-form').reset()
      //remove the classlist that makes the product info fixed to screen
      //its likely that we are not using this anymore since sliding add to cart button directly adds the product in the cart
      //instead of displaying sticky the product information section in the screen
      this.removeClassFromListUniv(document.querySelector('.product__info-wrapper.watch-distance'), 'product__info-wrapper-fix-to-screen') 
      this.addClassFromListUniv(this.notifyMeMainContainer, 'display-notify-modal')
      this.notifyFormErrorMessage.style.display = 'none'
      this.notifyFormErrorMessage.innerHTML = '<span class="notify-error-closebtn" onclick="this.parentElement.style.display=\'none\';">&times;</span>'
    }

    submitBackInStock(e) {
      e.preventDefault();
      let formData = new FormData(this.backInStockSubmitForm);

      let notifyMeEmail = formData.get('email')
      let notifyMeCatalogVariant = formData.get('notify-me-catalog-variant')
      //let notifyFormErrorMessage = document.querySelector('.notify-form-error-message')
      //let notifyMeSubmitButton = document.querySelector('#notify-me-submit-button')

      if (!notifyMeEmail || !notifyMeCatalogVariant)  {
        this.notifyFormErrorMessage.innerHTML = '<span class="notify-error-closebtn" onclick="this.parentElement.style.display=\'none\';">&times;</span>Email and Variant must not be blank'
        this.notifyFormErrorMessage.style.display = 'block'
        return
      }
      const payload = {
                  "data": {
                    "type": "back-in-stock-subscription",
                    "attributes": {
                      "profile": {
                        "data": {
                            "type": "profile",
                            "attributes": {
                                "email": notifyMeEmail,
                            }
                        }
                      },
                      "channels": ["EMAIL"],
                    },
                    "relationships": {
                      "variant": {
                        "data": {
                          "type": "catalog-variant",
                          "id": "$shopify:::$default:::" + notifyMeCatalogVariant
                        }
                      }
                    }
                  }
      }

      var requestOptions = {
          method: 'POST',
          headers: {
              accept: 'application/json',
              revision: '2023-12-10',
              'content-type': 'application/json'                                       
          },
          body: JSON.stringify(payload),
      };


      fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=TdKfBm",requestOptions)
      .then((response) => {
        if (response.ok) {
          this.notifyFormErrorMessage.innerHTML = '<span class="notify-error-closebtn" onclick="this.parentElement.style.display=\'none\';">&times;</span>Success!'
          this.notifyFormErrorMessage.style.backgroundColor = '#5CB85C'
          this.notifyFormErrorMessage.style.display = 'block'
          document.querySelector('#notify-me-email').value = ""
                setTimeout( (notifyMeEmail) => {
                      this.notifyFormErrorMessage.style.display = 'none'
                      this.notifyMeMainContainer.classList.remove("display-notify-modal")
                      this.notifyFormErrorMessage.innerHTML = '<span class="notify-error-closebtn" onclick="this.parentElement.style.display=\'none\';">&times;</span>'
                },
                1000)
          
          return {"status": "success1"}
        } else {
          this.notifyFormErrorMessage.innerHTML = `<span class="notify-error-closebtn" onclick="this.parentElement.style.display=\'none\';">&times;</span>Server error occured. Please try again!`
          this.notifyFormErrorMessage.style.backgroundColor = '#F8CFD7'
          this.notifyFormErrorMessage.style.display = 'block'
          return response.json()
        }
      })
      .catch((error) => {
          notifyFormErrorMessage.innerHTML = `<span class="notify-error-closebtn" onclick="this.parentElement.style.display=\'none\';">&times;</span>Process error occured. Please try again!`
          notifyFormErrorMessage.style.backgroundColor = '#F8CFD7'
          notifyFormErrorMessage.style.display = 'block'

      });

    }

    //notify me scripts end

    //create an observer for the add to cart button
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        if(entries[0].isIntersecting && this.slidingAddToCartContainer) {
          this.slidingAddToCartContainer.classList.remove('show-sliding-cart')
        }

        if(!entries[0].isIntersecting && this.slidingAddToCartContainer) {
          this.slidingAddToCartContainer.classList.add('show-sliding-cart')
        }
      }, {rootMargin: "-150px 0px 0px 0px"});
      
      observer.observe(this.addToCartObserve);

    }

    connectedCallback() {
      if (window.Rebuy && window.Rebuy._status !== 'initialized') {
        this.disableForm();
      }
    }

    disableForm() {
      if(this.submitButton) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
      }

      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    }

    enableForm() {
      //console.log('form-enabled')
      if(this.submitButton) {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
      }

      this.querySelector('.loading-overlay__spinner').classList.add('hidden');

    //   window.onload = function() {
    //     const queryString = window.location.search;
    //     if(queryString) {
    //         const urlParams = new URLSearchParams(queryString);
    //         const scrollTo = urlParams.get('scrollTo')
    //         if(scrollTo) {
    //             setTimeout(()=> {
    //               const element = document.getElementById(scrollTo)
    //               if(element) {
    //                 element.scrollIntoView({behavior: 'smooth', block: 'center'});
    //               }
    //             }, 10)
    //         }
    //     }
  
    // };
    
                setTimeout(()=> {
                  const element = document.querySelector('.faqCloseBtn')
                  if(element) {
                    element.classList.add('showfaqCloseBtn');
                  }
                }, 10)

    }

   onSubmitHandler(evt) {
      evt.preventDefault();
      const isCheckout = evt.submitter && evt.submitter.name === 'checkout';
      const formData = new FormData(this.form);

      // sliding add to cart button code
      // we will show the loading spinner icon here
      if(document.querySelector('.sliding-add-to-cart-container.show-sliding-cart .loading-overlay__spinner')) {
            document.querySelector('.sliding-add-to-cart-container.show-sliding-cart .loading-overlay__spinner').classList.remove('hidden');
      }


      // Prevents adding duplicates to the cart
      if (window.Rebuy && window.Rebuy.Cart) {
        this.disableForm();

        if (formData.has('subscription_btn')) {
          const subscriptionBtn = formData.get('subscription_btn');
          const productId = formData.get('id');
          if (!subscriptionBtn || subscriptionBtn === 'null') return;

          fetch(window.Shopify.routes.root + 'products/' + subscriptionBtn + '.js')
            .then(response => response.json())
            .then(subscriptionProductData => {
              const variantId = subscriptionProductData.variants[0].id;
              const sellingPlanId = subscriptionProductData.selling_plan_groups[0].selling_plans[0].id;

              window.Rebuy.Cart.addItem(
                {
                  quantity: 1,
                  id: variantId,
                  selling_plan: sellingPlanId,
                  properties: {
                    _parent_id: productId,
                  }
                }
              );
            });

                //in case you wanted to unfix the product__info section (where the add to cart button is located) after adding to cart
                //just uncomment this below
                //document.querySelector('.product__info-wrapper.watch-distance').classList.remove('product__info-wrapper-fix-to-screen')
        }

        return; // Rebuy will automatically take care of adding the product to cart
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      this.productId = this.form.id.getAttribute('data-productid');
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
              }

          this.error = false;

          if (isCheckout) {
            window.location = window.shopUrl + '/checkout';
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const resp = this.addFreeSubscriptionProduct(this);
          if(!resp) {
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          }

          setTimeout(() => {
            this.cart.open();
          }, 100);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          // sliding add to cart button code
          // we will remove the loading spinner icon here
          if (document.querySelector('.sliding-add-to-cart-container.show-sliding-cart .loading-overlay__spinner')) {
            document.querySelector('.sliding-add-to-cart-container.show-sliding-cart .loading-overlay__spinner').classList.add('hidden');
          }
          
                  //in case you wanted to unfix the product__info section (where the add to cart button is located) after adding to cart
                  //just uncomment this below
                  //document.querySelector('.product__info-wrapper.watch-distance').classList.remove('product__info-wrapper-fix-to-screen')
        });
    }
addFreeSubscriptionProduct(evt) {
      return false;
    }
    /*async addFreeSubscriptionProduct(evt) {
      //check if subscription is taken
      if(this.querySelector('.subscription-btn')) {
        const subsUid = this.querySelector('input[name="subscription_btn"]:checked').value;
        if(subsUid != null) {
          var subsHandle;
          switch(subsUid) {
            case '7395343368342':
              subsHandle = 'renew-hydratingpeptides™-serum';
              break;
            case '7417192480918':
              subsHandle = 'daily-cell-regeneration-system-first-month-free';
              break;
            case '7395351822486':
                subsHandle = 'refinish-acid-serum-exclusive-offer';
                // subsHandle = 'refinish-acid-serum-first-month-free';
                break;
            default:
              subsHandle = '';
          }
          // subsHandle = 'personal-microderm-elite-pro';
          if(subsHandle != '') {
            const getBody = {
              method: 'GET',
              headers: { 'Content-Type': 'application/json', 'Accept': `application/json`}
            };

            // fetch('https://pmdb.myshopify.com/admin/api/2022-04/products/' + this.form.id.value+'.json', getBody)
            const product = await this.getProductBySlug(subsHandle);
            if((product !== null) && (typeof product != 'undefined')) {
              const variantId = product.variants.length > 0 ? product.variants[0].id : '';
              if(variantId != '') {
                let formData1 = new FormData();
                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];
                if (this.cart) {
                  formData1.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                  formData1.append('sections_url', window.location.pathname);
                  formData1.append('id', variantId);
                  formData1.append('quantity', 1);
                  formData1.append('properties[parent_product_id]', this.productId);
                  this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData1;
                const response = await fetch(`${routes.cart_add_url}`, config);
                if(response.ok) {
                  const returnRes = await response.json();
                  const quickAddModal = this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener('modalClosed', () => {
                      setTimeout(() => { this.cart.renderContents(returnRes) });
                    }, { once: true });
                    quickAddModal.hide(true);
                  } else {
                    this.cart.renderContents(returnRes);
                  }
                  return true;
                  // return returnRes;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            } else {
              return true;
            }
          }

        }
      };
    }*/

    async getProductBySlug(slug) {
      const response = await fetch(window.Shopify.routes.root + 'products/' + slug +'.js', { ...getConfig() })
      if (!response.ok) {
        return null;
      } else {
        const product =  await response.json();
        return product;
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
